import ProjectButton from "./ProjectButton";
import classes from "./ProjectButton.module.css";
import { Fragment } from "react";

import ejs from "../../assets/logo.png";
import globus from "../../assets/logoG.png";

const ProjectButtons = (props) => {
  return (
    <Fragment>
      <h1 className={classes.header}>Choose project</h1>
      <div className={`${classes.grid} ${classes.margins}`}>
        <div>
          <ProjectButton photo={ejs} onClick={props.onEjs} />
          <p className={classes.info}>2019-1-PL01-KA229-065637</p>
          <p className={classes.info}>
            Szkoła bez granic - English - just speak!
          </p>
        </div>
        <div>
          <ProjectButton photo={globus} onClick={props.onGlob} />
          <p className={classes.info}>2020-1-PL01-KA101-078463</p>
          <p className={classes.info}>
            Młodzi poligloci - najlepsi z najlepszych
          </p>
        </div>
      </div>
    </Fragment>
  );
};

export default ProjectButtons;
